import React from 'react';
import TopicCard from '../components/TopicCard/TopicCard';
import styles from './Pages.module.css';

const HomePage: React.FC = () => {
  const topics = [
    { title: 'Introduction', description: 'Foundations of CS, including Big O notation.', path: '/intro', icon: '📚' },
    { title: 'Searching Algorithms', description: 'Master linear and binary search.', path: '/search', icon: '🔍' },
    { title: 'Sorting Algorithms', description: 'Visualize how data is sorted with Quick Sort and more.', path: '/sort', icon: '🔢' },
    { title: 'Linear Data Structures', description: 'Explore arrays, linked lists, and more.', path: '/lists', icon: '🔗' },
    { title: 'Recursion', description: 'Understand how functions call themselves.', path: '/recursion', icon: '🔄' },
    { title: 'Trees', description: 'Learn about binary trees and tree traversals.', path: '/trees', icon: '🌳' },
    { title: 'Advance Trees', description: 'Specialized tree structures for priority and search.', path: '/advancetrees', icon: '🌲' },
    { title: 'Graphs', description: 'Navigate networks and find the shortest path.', path: '/graph', icon: '🕸️' },
    { title: 'Maps & Caches', description: 'Explore key-value data storage and LRU caches.', path: '/map', icon: '🗺️' },
  ];

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>DSA Visualizer</h1>
      <p className={styles.subtitle}>
        Learn and understand data structures and algorithms through interactive visualizations.
      </p>
      <div className={styles.cardGrid}>
        {topics.map((topic) => (
          <TopicCard
            key={topic.title}
            title={topic.title}
            description={topic.description}
            link={topic.path}
            icon={topic.icon}
          />
        ))}
      </div>
    </div>
  );
};

export default HomePage;